import { useEffect } from "react";

/**
 * Closes an open anchor-positioned popup (e.g. a Dropdown) on the first
 * scroll of its trigger's scroll parent or the window.
 *
 * Row actions live in an unpinned table column, so the trigger scrolls with
 * the row underneath an open, anchor-positioned popup. AntD/rc-trigger then
 * has to keep re-aligning against a moving target — in RTL that realignment
 * can thrash (flipping placement back and forth) badly enough to throw and
 * take down the whole page (no error boundary catches it below the route
 * level). Closing on the first scroll tick sidesteps the live realign
 * entirely instead of trying to make it robust.
 */
export default function useCloseOnScroll(triggerRef, open, setOpen) {
  useEffect(() => {
    if (!open) return undefined;

    // `.bar-auto-hide` is the page column itself (AppLayout): the window never scrolls.
    const scrollParent = triggerRef.current?.closest(
      ".ant-table-content, [class*='overflow-x-auto'], [class*='overflow-auto'], .bar-auto-hide"
    );
    const handleScroll = () => setOpen(false);

    scrollParent?.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      scrollParent?.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [open]);
}
